import { memo } from 'react';
import { clsx } from 'clsx';
import styles from './ProductStockIndicator.module.scss';

const ProductStockLoadingIndicator = ({
    lineIndicator = false,
    square = false,
    ...ariaProps
}: {
    lineIndicator?: boolean;
    square?: boolean;
}) => {
    return (
        <div
            className={clsx(styles.stockIndicator, styles.unavailable, {
                [styles.lineIndicator]: lineIndicator,
                [styles.square]: square,
            })}
            {...ariaProps}
        />
    );
};

export default memo(ProductStockLoadingIndicator);
